export function HelpPage() {
  return (
    <div className="product-page" style={{ maxWidth: "720px" }}>
      <h1 className="page-title">Help &amp; Support</h1>
      <p className="page-subtitle">
        Frequently asked questions and how to get in touch.
      </p>

      <section className="product-section" aria-labelledby="faq-heading">
        <h2 id="faq-heading" className="section-title">
          Frequently asked questions
        </h2>

        <details open className="mb-3">
          <summary className="cursor-pointer fw-600">
            What accessibility standards does AccessiMonitor test against?
          </summary>
          <p className="text-muted mt-2">
            AccessiMonitor tests against WCAG 2.1 and WCAG 2.2 at levels A and
            AA. You can choose your target standard in your website scan
            settings. Results are also mapped to EN 301 549 for EU public-sector
            compliance.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            How does the scan depth work?
          </summary>
          <p className="text-muted mt-2">
            Scan depth controls how many pages are accessibility-scanned per
            run. Discovery may find more pages, but only pages within your
            plan&apos;s depth limit are scanned for issues. Deeper scans catch
            more issues across your site; shallower scans are faster and cover
            representative pages.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            How do I add my website to AccessiMonitor?
          </summary>
          <p className="text-muted mt-2">
            Navigate to <strong>Websites</strong> in the top menu and click{" "}
            <strong>Add website</strong>. The setup wizard will guide you
            through entering your URL, choosing a scan depth, and configuring
            your accessibility statement.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            What is the accessibility statement?
          </summary>
          <p className="text-muted mt-2">
            An accessibility statement is a public-facing page that documents
            your website&apos;s accessibility status and how users can report
            issues. AccessiMonitor generates one automatically based on your
            scan results. It is required for EU public-sector websites under the
            Web Accessibility Directive and good practice for all organisations.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            My site has a WAF or bot protection — how do I allow the scanner?
          </summary>
          <p className="text-muted mt-2">
            The scanner identifies itself with a custom User-Agent and sends{" "}
            <code>X-AccessiMonitor: 1</code> and{" "}
            <code>X-AccessiMonitor-Purpose: accessibility-scan</code> headers.
            You can allowlist requests matching these identifiers in your WAF or
            bot protection settings. No fixed scanner IP is currently available.
          </p>
          <p className="text-muted mt-2">
            <strong>Note:</strong> Ownership verification checks (HTML meta tag
            or file-based) use a different identity from scan traffic. They
            send <code>X-AccessiMonitor-Purpose: ownership-verification</code>{" "}
            instead. Allowlisting the scanner does not prove ownership and does
            not affect verification checks.
          </p>
          <p className="text-muted mt-2">
            Visit your website&apos;s <strong>Settings</strong> page for full
            allowlisting details and a copy button.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            Can I scan password-protected pages?
          </summary>
          <p className="text-muted mt-2">
            Yes. In the setup wizard, select <strong>Protected site</strong> and
            provide credentials. AccessiMonitor uses a headless browser to sign
            in before scanning.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            Will the scan appear in my analytics?
          </summary>
          <p className="text-muted mt-2">
            No. AccessiMonitor blocks analytics tracking (Google Analytics, Meta
            Pixel, LinkedIn Insight Tag, and many others) at the network level
            during scans. Scans are identified by the{" "}
            <code>X-AccessiMonitor: 1</code> request header and a custom
            user-agent so you can filter them server-side if needed.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            How often does AccessiMonitor scan my website?
          </summary>
          <p className="text-muted mt-2">
            You can set your scan frequency to monthly,
            quarterly, or never (manual only) in your website settings.
            Automated scans run in the background and can email you the
            results. You can control scan-result emails from your organisation
            settings.
          </p>
        </details>

        <details className="mb-3">
          <summary className="cursor-pointer fw-600">
            What are the plan limits?
          </summary>
          <p className="text-muted mt-2">
            Plan limits control how many websites you can monitor and how many
            pages are scanned per run. You can view your current plan and limits
            on the <strong>Billing</strong> page. If you need more, you can
            upgrade at any time.
          </p>
        </details>
      </section>

      <section className="product-section" aria-labelledby="contact-heading">
        <h2 id="contact-heading" className="section-title">
          Contact support
        </h2>
        <p className="text-muted">
          If you have a question not covered above or need technical assistance,
          please email us at{" "}
          <a href="mailto:support@accessimonitor.app">
            support@accessimonitor.app
          </a>
          . We aim to respond within one business day.
        </p>
        <p className="text-muted mt-2">
          For urgent issues affecting EU public-sector compliance deadlines,
          please mention this in your subject line and we will prioritise your
          request.
        </p>
      </section>
    </div>
  );
}
